module.exports = __webpack_public_path__ + "media/AOCs_27oct_final.70de99d1.mp4";